// 该文件由 vite-plugin-version-generator 自动生成
// 不要手动编辑此文件，它会在每次构建时自动生成

export const VERSION_INFO = {
  "version": "3.6",
  "major": 3,
  "minor": 6,
  "timestamp": 1793871644723,
  "buildTime": "2026-11-05 17:40:44"
} as const;

export const APP_VERSION = VERSION_INFO.version;
export const BUILD_TIME = VERSION_INFO.buildTime;
export const BUILD_TIMESTAMP = VERSION_INFO.timestamp;
